import { render, staticRenderFns } from "./FundingAccount.vue?vue&type=template&id=54a41ed2&scoped=true"
import script from "./FundingAccount.vue?vue&type=script&lang=js"
export * from "./FundingAccount.vue?vue&type=script&lang=js"
import style0 from "./FundingAccount.vue?vue&type=style&index=0&id=54a41ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a41ed2",
  null
  
)

export default component.exports